// Production uses the original workbook views until exact data parity is proven.
// A similar trend or rounded API values are not replacement approval.
export const APPROVED_NATIVE_REPLACEMENTS = Object.freeze([]);

export const ORIGINAL_ANALYSES = {
  region: [
    { name:'시도별 분석', url:'real_region_summary1_richgo/sd_01', authorityLevel:100, category:'realestate', groups:['summary','affordability'] },
    { name:'시군구별 분석', url:'real_region_summary2_richgo/sgg_01', authorityLevel:100, category:'realestate', groups:['summary','affordability'] },
    { name:'지역별 시세·지수 흐름 비교', url:'real_richgo_ai_price_region/region_several_price_trend_01', authorityLevel:100, category:'realestate', groups:['price'] },
    { name:'매매전세지수 전세가율(시군구)', url:'real_priceindex_stat/index_rent_price_deviation_01', authorityLevel:100, category:'realestate', groups:['price'] },
    { name:'실거래량', url:'real_molit_apt/vol_apt_01', authorityLevel:100, category:'realestate', groups:['activity'] },
    { name:'매물지수(지역별, 주간)', url:'real_opengoods1/opengoods_region_daily_01', authorityLevel:200, category:'realestate', groups:['activity'] },
    { name:'차트 분석', url:'real_demand2/supply_volume_02', authorityLevel:100, category:'realestate', groups:['supply'] },
    { name:'미분양', url:'real_demand2/unsold_02', authorityLevel:100, category:'realestate', groups:['supply'] }
  ],
  economy: [
    { name:'M1/M2 통화량 대비 시가총액', url:'eco_korea_cap/cap_m1_m2_01', authorityLevel:100, category:'economy', groups:['economy'] },
    { name:'GDP 대비 시가총액', url:'eco_korea_gdp/gdp_cap_01', authorityLevel:100, category:'economy', groups:['economy'] }
  ]
};

export function originalCharts(mode, groupIds = null) {
  const charts = ORIGINAL_ANALYSES[mode] || [];
  return groupIds === null ? charts : charts.filter(chart => chart.groups.some(group => groupIds.includes(group)));
}
